<template>
    <div class="main-block request-management">
        <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.Insights') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <router-link :to="{ name: 'AddScheduledTasks', params: { operation: 'add' } }"
                            class="btn btn-primary">
                            <b-icon icon="plus" class="icon-style"></b-icon>
                            {{ $t('title.addnew') }}
                        </router-link>
                    </template>

                    <template #cell(actions)="{ item }">
                        <b-button variant="Primary" v-b-tooltip.hover title="Delete"  @click="openModal(item)">
                            <b-icon variant="danger" icon="trash" class="icon-style"></b-icon>
                        </b-button>

                        <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteModalLabel">{{ $t('title.confirmDeletionTask')
                                        }}</h5>
                                    </div>
                                    <div class="modal-body">
                                        {{ $t('title.deleteTask') }}
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" @click="closeModal">
                                            {{ $t('title.cancel') }}
                                        </button>
                                        <button type="button" class="btn btn-danger" @click="deleteItem">
                                            {{ $t('title.yes') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-button variant="Primary" v-b-tooltip.hover title="Edit" 
                            @click="$router.push({ name: 'UpdateScheduledTasks', params: { id: item.id, operation: 'edit' } })">
                            <b-icon variant="primary" icon="pencil-square" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <template #cell(is_active)="{ item }">
                        <b-button variant="Primary"  @click="toggleStatus(item.id, item.is_active)">
                            <b-icon :variant="item.is_active ? 'success' : 'secondary'"
                                :icon="item.is_active ? 'toggle-on' : 'toggle-off'" class="icon-style"></b-icon>
                        </b-button>
                    </template>
                    <template #cell(is_run)="{ item }">
                        <b-button v-if="item.is_active" variant="success" @click="runNow(item.id)">
                            <b-icon icon="play-circle" class="icon-style"></b-icon>
                            {{ $t('title.runNow') }}
                        </b-button>
                    </template>
                </crud-table>
            </div>
        </div>
    </div>
</template>

<script>
import {
    request
} from "@/Util/Request";
import {
    mapState
} from "vuex";
import {
    Modal
} from "bootstrap";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null
};

const COLUMN_STATE = (self) => [{
    key: 'actions',
    label: self.$t('title.actions')
},
{
    key: 'name',
    label: self.$t('title.name'),
    sortable: true
},
{
    key: 'type',
    label: self.$t('title.scheduled_type'),
    sortable: true
},
{
    key: 'start_time',
    label: self.$t('title.start_time'),
    sortable: true
},
{
    key: 'end_time',
    label: self.$t('title.end_time'),
    sortable: true
},
{
    key: 'description',
    label: self.$t('title.description'),
    sortable: true
},
{
    key: 'email',
    label: self.$t('title.email'),
    sortable: true
},
{
    key: 'is_active',
    label: self.$t('title.status'),
    sortable: true
},
{
    key: 'is_run',
    label: self.$t('title.run'),
    sortable: true
},

];

export default {
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0,
            },
            listUrl: '/admin/scheduled-task',
            filters: {
                ...FILTER_FORM
            },
            showPopup: false,
            selectedItemId: null,
        };
    },
    components: { Breadcrumbs },
    methods: {

        openModal(item) {
            console.log("Opening modal for item:", item);
            this.selectedItemId = item.id; // Store the item ID
            const modalElement = document.getElementById("deleteModal");
            this.modalInstance = new Modal(modalElement);
            this.modalInstance.show();
        },

        closeModal() {
            if (this.modalInstance) {
                this.modalInstance.hide();
            }
        },

        async deleteItem() {
            if (!this.selectedItemId) {
                console.error("No ID selected for deletion!");
                return;
            }

            try {
                console.log("Deleting item with ID:", this.selectedItemId);
                await request({
                    method: 'delete',
                    url: `/admin/scheduled-task/${this.selectedItemId}`,
                });

                if (this.modalInstance) {
                    this.modalInstance.hide();
                    this.showToast(
                        this.$t("title.ScheduledTaskDeletedTitle"),
                        this.$t("title.ScheduledTaskDeletedMessage")
                    );
                }

                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        async toggleStatus(id, is_active) {
            try {
                const response = await request({

                    method: 'get',
                    url: `/admin/scheduled-task/change-status/${id}`,
                });

                const titleKey = is_active == 1 ? "title.TaskDeactivatedTitle" : "title.TaskActivatedTitle";
                const messageKey = is_active == 1 ? "title.TaskDeactivatedMessage" : "title.TaskActivatedMessage";

                this.showToast(this.$t(titleKey), this.$t(messageKey), is_active == 1 ? null : 1);

                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        handleFilter() {
            this.$refs['application-table'].handleFilter(this.filters);
        },
        resetFilter() {
            this.filters = {
                ...FILTER_FORM
            };
        },
        async runNow(id) {
            try {
                const response = await request({
                    method: 'post',
                    url: `/admin/scheduled-task/run/${id}`,
                });
                this.showToast(this.$t("title.TaskRunSuccess"), this.$t("title.TaskRunMessage"), 1);
            } catch (error) {
                this.showToast(this.$t("title.TaskRunError"), this.$t("title.TaskRunErrorMessage"), 0);
            }
        },
        showToast(title, msg, status) {
            const h = this.$createElement;
            const vNodesMsg = h('p', {
                class: ['text-center', 'mb-0']
            }, [msg]);
            const vNodesTitle = h('div', {
                class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2']
            },
                [h('strong', {
                    class: 'mr-2'
                }, title)]
            );

            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: status === 1 ? 'primary' : 'danger',
            });
        }

    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
